export const translations = {
  tr: {
    nav: {
      home: "Ana Sayfa",
      about: "Hakkımızda",
      services: "Hizmet Alanları",
      team: "Ekip",
      contact: "İletişim",
    },
    hero: {
      eyebrow: "İstanbul · Boğaziçi",
      title: "Boğaz'ın iki yakasında, hukuki sezginin merkezinde.",
      subtitle:
        "Alaca Partners, kurumsal yapılanmadan uyuşmazlık çözümüne kadar geniş bir yelpazede; titiz, sade ve sonuç odaklı bir hukuki danışmanlık sunar.",
      cta_primary: "Bizimle çalışın",
      cta_secondary: "Hizmet alanları",
    },
    intro: {
      eyebrow: "Bir bakışta",
      title: "Yüzyıllık bir silüet. Yeni nesil bir hukuk pratiği.",
      body: "Üsküdar Kız Kulesi'nin huzurlu duruşundan ilham alan Alaca Partners; modern hukukun karmaşıklığını, klasik bir titizlikle çözer. Müvekkillerimize yalnızca hukuki sonuçlar değil; netlik, güven ve stratejik avantaj sunarız.",
    },
    services: {
      eyebrow: "Hizmet alanları",
      title: "Karmaşıklığı yönetin. Önceliklerinizi koruyun.",
      cta: "Tüm hizmetler",
    },
    team: {
      eyebrow: "Ekibimiz",
      title: "Tecrübeli ortaklar, derinleşen uzmanlık.",
      cta: "Ekibi tanıyın",
    },
    contact: {
      eyebrow: "İletişim",
      title: "Bir görüşme planlayın.",
      subtitle: "Bize meselenizi anlatın; 24 saat içinde dönüş yapalım.",
      name: "Adınız",
      email: "E-posta",
      phone: "Telefon",
      subject: "Konu",
      message: "Mesajınız",
      submit: "Gönder",
      success: "Mesajınız iletildi. Teşekkür ederiz.",
      error: "Bir hata oluştu. Lütfen tekrar deneyin.",
    },
    about: {
      eyebrow: "Hakkımızda",
      title: "Boğaz'ın iki yakasında, sezgili bir hukuk pratiği.",
      body1:
        "Alaca Partners, İstanbul merkezli bir hukuk bürosu olarak, ulusal ve sınır ötesi müvekkillerine kapsamlı hukuki çözümler sunar. Çalışmalarımızın merkezinde, müvekkillerimizin ticari hedeflerine hizmet eden açık, sağlam ve uygulanabilir tavsiyeler vardır.",
      body2:
        "Üsküdar Kız Kulesi'nin sembolize ettiği güven ve süreklilik, kuruluş felsefemizin temel taşıdır. Boğaz'ın iki yakasını birbirine bağlayan bu silüet gibi, biz de hukukun farklı disiplinlerini ve müvekkillerimizin küresel beklentilerini bir araya getiriyoruz.",
      values_title: "Değerlerimiz",
      values: [
        { t: "Titizlik", d: "Her detay, sonucu belirler." },
        { t: "Sezgi", d: "Hukuk kadar, ticari mantık." },
        { t: "Süreklilik", d: "Müvekkillerimizin yanında uzun yıllar." },
        { t: "Sadelik", d: "Karmaşadan değil, netlikten yana." },
      ],
    },
    footer: {
      tagline: "Boğaz'ın iki yakasında, hukuki sezginin merkezinde.",
      address: "Levent, İstanbul · Türkiye",
      rights: "Tüm hakları saklıdır.",
      admin: "Yönetim",
    },
    common: { learn_more: "Detay", lang_switch: "EN" },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Practice Areas",
      team: "People",
      contact: "Contact",
    },
    hero: {
      eyebrow: "Istanbul · Bosphorus",
      title: "On both shores of the Bosphorus, at the heart of legal intuition.",
      subtitle:
        "Alaca Partners delivers measured, results-driven counsel across corporate structuring, transactions, and dispute resolution.",
      cta_primary: "Work with us",
      cta_secondary: "Practice areas",
    },
    intro: {
      eyebrow: "At a glance",
      title: "A century-old silhouette. A modern legal practice.",
      body: "Drawing inspiration from the quiet poise of the Maiden's Tower, Alaca Partners untangles the complexity of modern law with classical rigor. We offer not only legal outcomes but clarity, confidence, and strategic advantage.",
    },
    services: {
      eyebrow: "Practice areas",
      title: "Navigate complexity. Protect what matters.",
      cta: "All practices",
    },
    team: {
      eyebrow: "Our people",
      title: "Seasoned partners. Deepening expertise.",
      cta: "Meet the team",
    },
    contact: {
      eyebrow: "Contact",
      title: "Schedule a conversation.",
      subtitle: "Tell us about your matter and we will respond within 24 hours.",
      name: "Name",
      email: "Email",
      phone: "Phone",
      subject: "Subject",
      message: "Your message",
      submit: "Send message",
      success: "Your message has been received. Thank you.",
      error: "Something went wrong. Please try again.",
    },
    about: {
      eyebrow: "About us",
      title: "An intuitive legal practice spanning the Bosphorus.",
      body1:
        "Alaca Partners is an Istanbul-based law firm serving domestic and cross-border clients with comprehensive legal solutions. At the core of our work lies clear, robust, and actionable advice that serves our clients' commercial objectives.",
      body2:
        "The trust and continuity symbolized by the Maiden's Tower are the cornerstones of our founding philosophy. Like that silhouette which connects the two shores of the Bosphorus, we bring together different legal disciplines and the global expectations of our clients.",
      values_title: "Our values",
      values: [
        { t: "Rigor", d: "Every detail shapes the outcome." },
        { t: "Intuition", d: "Commercial sense alongside law." },
        { t: "Continuity", d: "Decade-long client relationships." },
        { t: "Restraint", d: "Clarity over noise." },
      ],
    },
    footer: {
      tagline: "On both shores of the Bosphorus, at the heart of legal intuition.",
      address: "Levent, Istanbul · Türkiye",
      rights: "All rights reserved.",
      admin: "Admin",
    },
    common: { learn_more: "Read", lang_switch: "TR" },
  },
};
